import { CommApiInstance } from "Utils/CommApiInstance";


const GameSvcMainPageInfoInqApi = async (
    gameSvcCd:string,
) => {
    return await CommApiInstance.post(`${gameSvcCd}/main_page`,{
        apiBody: {
        }
    })
    .then((Resp) => Resp.data.apiBody);
}

export default GameSvcMainPageInfoInqApi;